module Client.Components.Graph.DistanceSensor

open Client.Components.Graph.Recharts
open Client.Components.GraphCommon
open Client.Domain.MeasuredValueString
open Feliz.Recharts
open Fulma
open Shared.Dto.MapSensorData
open Shared.Dto.SensorGraphData
open Shared.Infrastructure

type DistanceGraphNode = {
    Ticks: double
    Distance: int
}

let toDistanceSensorGraphData (data: GraphDistanceDataDto) : DistanceGraphNode = {
    Ticks = data.TimeStamp.ToUnixTimeSeconds() |> double
    Distance = data.Distance
}

let mapDataToDistance (data: GraphDataDto) =
    match data with
    | Distance data -> Some data
    | _ -> None

let currentDistanceDataBox (data: DistanceData) = [
    Level.level [] [
        currentDataLevelItem "Wann?" (DateTime.toDateTimeString data.Date.LocalDateTime)
        currentDataLevelItem "Distanz" (distanceToString data.Distance)
    ]
]

let private createDistanceYAxisTicks (data: DistanceGraphNode list) =
    let values = data |> List.map (fun item -> item.Distance)

    let min = List.min values
    let max = List.max values

    AxisTicks.generate true 5. min max

let private yAxisTickFormatter (unit: string) (factor: float) (value: float) = sprintf "%.2f %s" (value / factor) unit

let distanceDataGraphs (graphData: SimpleGraphData<DistanceGraphNode>) =
    let xDomain = xAxis.domain (domain.min, domain.max)
    let yDomain = yAxis.domain (domain.min, domain.max)
    let xAxisTickInterval = xAxis.interval.preserveStartEnd

    let yAxisTicks = graphData.Data |> createDistanceYAxisTicks

    let maxTick = yAxisTicks |> List.max

    let unit, factor =
        if maxTick > 1000 then "m", 1000.
        else if maxTick > 100 then "cm", 100.
        else "mm", 1.

    let distanceYAxisTicks = AxisTicks.createYProperty yAxisTicks

    let dataKey = (fun (p: DistanceGraphNode) -> p.Ticks) |> xAxis.dataKey

    let distanceChart =
        Recharts.lineChart [
            lineChart.syncId "syncId1"
            lineChart.data graphData.Data
            lineChart.children [
                Recharts.xAxis [
                    dataKey
                    xAxis.number
                    xAxis.scale.time
                    xAxis.tickFormatter formatTimeTick
                    xDomain
                    xAxisTickInterval
                ]
                Recharts.yAxis [
                    yAxis.number
                    distanceYAxisTicks
                    yAxis.tickFormatter (yAxisTickFormatter unit factor)
                    yDomain
                ]
                Recharts.legend []
                Recharts.tooltip [ tooltip.content tooltipContent ]
                Recharts.line [
                    line.dot false
                    line.dataKey (fun p -> p.Distance)
                    line.name "Distanz [mm]"
                    line.stroke "#cc9933"
                ]

                Recharts.cartesianGrid [ cartesianGrid.strokeDasharray [| 3; 3 |] ]
            ]
        ]
        |> fullHeightGraphBox "Verlauf der Distanz"


    [ distanceChart ]

let graphDataToDistanceGraphData (data: GraphDistanceDataDto list) =
    data |> List.map toDistanceSensorGraphData |> (fun list -> { Data = list })